import { render, staticRenderFns } from "./ClaimReserveInfo.vue?vue&type=template&id=ad376d00&"
import script from "./ClaimReserveInfo.vue?vue&type=script&lang=js&"
export * from "./ClaimReserveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports